import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table-v6';

import { AddCircle } from '@mui/icons-material';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import 'react-table-v6/react-table.css';

import { useCallback } from 'react';
import AddContactModal from '../AddContactModal';

const ContactsList = (props) => {
    let [openModal, setOpenModal] = useState(false);
    const [contacts, setContacts] = useState();
    const [selectedContact, setSelectedContact] = useState();

    const fetchContacts = props.fetchContacts;

    const resolveContacts = useCallback(async () => {
        const contacts = await fetchContacts();
        setContacts(contacts);
    }, [fetchContacts]);

    useEffect(() => {
        resolveContacts();
    }, [resolveContacts]);

    const width =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    const columns = [
        {
            Header: 'Role',
            accessor: 'role',
            style: { paddingTop: 15 },
            show: width > 1000
        },
        {
            Header: 'Name',
            accessor: 'name',
            style: { paddingTop: 15 },
            Cell: (p) => {
                return p.value.first_name + ' ' + p.value.last_name;
            },
            
        },
        {
            Header: 'Title',
            accessor: 'title',
            style: { paddingTop: 15 },
            show: width > 1000,
        },
        {
            Header: 'Email',
            accessor: 'email',
            style: { paddingTop: 15 },
            show: width > 1000,
        },
        {
            Header: 'Phone Number',
            accessor: 'phone_number',
            style: { paddingTop: 15 },
        },
    ];

    return (
        <div className="space-list">
            <AddContactModal
                open={openModal}
                associateContact={props.associateContact}
                selectedContact={selectedContact}
                closeCallback={() => {
                    setOpenModal(false);
                }}
                onSubmit={resolveContacts}
            />
            <div className="space-add-mode">
                {contacts && contacts.length ? (
                    <Tooltip title="Add Contact">
                        <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={'Add Contact'}
                            onClick={() => {
                                setOpenModal(true);
                            }}
                        >
                            <AddCircle
                                style={{
                                    fill: '#00b088',
                                    background: 'white',
                                    transform: 'scale(1.0)',
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                ) : null}
            </div>
            <div className="section-header">Contacts </div>
            {contacts && contacts.length ? (
                <div className="point-list-table">
                    <ReactTable
                        key={(contacts && contacts.length) || 0}
                        data={contacts || []}
                        columns={columns}
                        minRows={0}
                        defaultPageSize={10}
                        showPagination={contacts && contacts.length > 10}
                        getTdProps={(state, rowInfo, column, instance) => {
                            return {
                              onClick: (e, handleOriginal) => {
                                console.log('It was in this row:', rowInfo)
                                setSelectedContact(rowInfo.original)
                                setOpenModal(true)
                              }
                            }
                          }}
                    />
                </div>
            ) : (
                <div className="bulk_add_prompt">
                    <IconButton
                        variant="contained"
                        color="primary"
                        aria-label={'Add Contacts'}
                        onClick={() => {
                            setOpenModal(true);
                        }}
                    >
                        <AddCircle style={{ fill: '#00b088', background: 'white' }} />
                    </IconButton>
                    There are currently no contacts configured. Add some now!
                </div>
            )}
        </div>
    );
};
ContactsList.propTypes = {
  fetchContacts: PropTypes.func.isRequired,
  associateContact: PropTypes.func.isRequired,
};

export default ContactsList;
